module.exports = __webpack_public_path__ + "img/VIP-8.abfc14af.png";